import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-deal-detail',
  templateUrl: './deal-detail.component.html',
  styleUrls: ['./deal-detail.component.scss']
})
export class DealDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
